module.exports = __webpack_public_path__ + "img/kids.2ff1efe5.svg";